import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import PageLayout from '../components/PageLayout';
import PageHeader from '../components/PageHeader';
import AccountSidebar from '../components/account/AccountSidebar';
import { ACCOUNT_TABS } from '../constants/accountTabs';
import { useAuth } from '../contexts/AuthContext';
import ProfileSection from './account/ProfileSection';
import SessionsSection from './account/SessionsSection';

const getTimeOfDayGreeting = (date = new Date()) => {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return 'Good morning';
  if (hour >= 12 && hour < 17) return 'Good afternoon';
  if (hour >= 17 && hour < 22) return 'Good evening';
  return 'Good night';
};

const getWelcomeTitle = (firstName) => {
  const name = String(firstName || '').trim() || 'there';
  return `${getTimeOfDayGreeting()}, ${name}`;
};

const tabFromSearchParam = (tabParam) => {
  const raw = String(tabParam || '').trim().toLowerCase();
  const match = ACCOUNT_TABS.find((tab) => tab.id === raw);
  return match?.id || 'profile';
};

const Account = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const activeTab = useMemo(
    () => tabFromSearchParam(searchParams.get('tab')),
    [searchParams]
  );

  const renderSection = () => {
    switch (activeTab) {
      case 'sessions':
        return <SessionsSection />;
      case 'profile':
      default:
        return <ProfileSection />;
    }
  };

  return (
    <PageLayout maxWidth="xl">
      <PageHeader title={getWelcomeTitle(user?.firstName)} />

      <Box
        sx={{
          display: 'flex',
          gap: 3,
          alignItems: 'flex-start',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <AccountSidebar activeTab={activeTab} />
        <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
          {renderSection()}
        </Box>
      </Box>
    </PageLayout>
  );
};

export default Account;
